// // ─── Formatters ────────────────────────────────────────────────────────────
// export const fmtHM = (mins) => {
//   const m = Math.max(0, Math.round(mins || 0));
//   const h = Math.floor(m / 60);
//   const mm = m % 60;
//   return `${String(h).padStart(2, "0")}h ${String(mm).padStart(2, "0")}m`;
// };

// export const ymd = (v) => {
//   const d = new Date(v);
//   if (isNaN(d)) return null;
//   const y = d.getFullYear();
//   const m = String(d.getMonth() + 1).padStart(2, "0");
//   const day = String(d.getDate()).padStart(2, "0");
//   return `${y}-${m}-${day}`;
// };

// export const todayISO = () => ymd(new Date());

// // ─── Attendance doc helpers ─────────────────────────────────────────────────
// export const pickEmployeeIdFromDoc = (doc) => {
//   const e = doc?.employee;
//   if (!e) return "";
//   if (typeof e === "string") return e;
//   if (typeof e === "object") return String(e._id || e.id || e.code || "");
//   return "";
// };

// export const msToMin = (ms) => Math.max(0, Math.round((ms || 0) / 60000));

// export const computeViewFromAttendance = (doc) => {
//   const workDay = doc?.workDay || ymd(doc?.createdAt) || ymd(Date.now());
//   const sessions = Array.isArray(doc?.sessions) ? doc.sessions : [];

//   const firstSession = sessions[0];
//   const lastSession = sessions[sessions.length - 1];

//   const rawIn = doc?.clockIn || firstSession?.in || null;
//   const rawOut = doc?.clockOut || lastSession?.out || null;

//   const workedMin = msToMin(doc?.workedMs);
//   const breakMin = msToMin(doc?.breakMs);

//   const fmt12 = (v) => {
//     const dt = v ? new Date(v) : null;
//     return dt instanceof Date && !isNaN(dt)
//       ? dt.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
//       : null;
//   };

//   const state = String(doc?.state || "").toUpperCase();
//   const isLive = state === "IN" || state === "BREAK";
//   const status = isLive || workedMin > 0 || rawIn ? "Present" : "Absent";
//   const employeeId = pickEmployeeIdFromDoc(doc);
//   const empPop = typeof doc?.employee === "object" ? doc.employee : null;

//   return {
//     _id: String(doc._id || ""),
//     employeeId,
//     _empPop: empPop,
//     date: `${workDay}T00:00:00.000Z`,
//     workDay,
//     in: fmt12(rawIn) || "",
//     out: fmt12(rawOut) || "",
//     hours: fmtHM(workedMin),
//     status,
//     _breakMin: breakMin,
//     _totalMin: workedMin,
//     _firstIn: rawIn ? new Date(rawIn) : null,
//     _lastOut: rawOut ? new Date(rawOut) : null,
//     _live: isLive,
//   };
// };

// // ─── Geo helpers ────────────────────────────────────────────────────────────
// export const haversineKm = (a, b) => {
//   if (
//     !a || !b ||
//     !Number.isFinite(a.lat) || !Number.isFinite(a.lng) ||
//     !Number.isFinite(b.lat) || !Number.isFinite(b.lng)
//   ) return Infinity;

//   const R = 6371;
//   const dLat = ((b.lat - a.lat) * Math.PI) / 180;
//   const dLng = ((b.lng - a.lng) * Math.PI) / 180;
//   const la1 = (a.lat * Math.PI) / 180;
//   const la2 = (b.lat * Math.PI) / 180;
//   const s1 = Math.sin(dLat / 2);
//   const s2 = Math.sin(dLng / 2);
//   return 2 * R * Math.asin(Math.sqrt(s1 * s1 + Math.cos(la1) * Math.cos(la2) * s2 * s2));
// };

// export const rangeLabel = (km) => {
//   if (!Number.isFinite(km)) return "No GPS";
//   if (km <= 0.5) return "In Office";
//   if (km <= 1.5) return "Nearby";
//   if (km <= 5) return "Moderate";
//   return "Far";
// };

// // ─── Employee helpers ───────────────────────────────────────────────────────
// export const getEmployeeDisplayName = (e) => {
//   if (!e) return "";
//   if (e.name) return e.name;
//   const fn = e.firstName || "";
//   const ln = e.lastName || "";
//   return (fn + " " + ln).trim() || e.code || e.id || "";
// };

// // ─── Date helpers ───────────────────────────────────────────────────────────
// export const pickDate = (r) => {
//   const candidates = [
//     r?.date,
//     r?.workDay && `${r.workDay}T00:00:00Z`,
//     r?.sessions?.[0]?.in,
//     r?.createdAt,
//     r?.updatedAt,
//   ].filter(Boolean);

//   for (const c of candidates) {
//     const d = new Date(c);
//     if (!Number.isNaN(d.getTime())) return d;
//   }
//   return null;
// };

// export const getMonthRange = (type) => {
//   const now = new Date();
//   const year = now.getFullYear();
//   const month = now.getMonth();

//   if (type === "thisMonth") {
//     return {
//       from: ymd(new Date(year, month, 1)),
//       to: ymd(new Date(year, month + 1, 0)),
//     };
//   }
//   if (type === "lastMonth") {
//     return {
//       from: ymd(new Date(year, month - 1, 1)),
//       to: ymd(new Date(year, month, 0)),
//     };
//   }
//   return null;
// };

// // ─── CSV export ─────────────────────────────────────────────────────────────
// export const toCSV = (rows) => {
//   const headers = [
//     "Employee ID", "Employee", "Date", "Check In", "Check Out",
//     "Hours", "Status", "Range Label", "Range (km)",
//   ];

//   const lines = rows.map((r) => {
//     const id = String(r.employeeId || r.employee || "");
//     const name = r._displayName || "";
//     const day = ymd(pickDate(r)) || r.workDay || "";
//     const dist = Number.isFinite(r._distKm) ? r._distKm.toFixed(2) : "";

//     return [
//       `"${id.replace(/"/g, '""')}"`,
//       `"${String(name).replace(/"/g, '""')}"`,
//       day,
//       r.in || "",
//       r.out || "",
//       r.hours || "",
//       r.status || "",
//       r._distLabel || "",
//       dist,
//     ].join(",");
//   });

//   return [headers.join(","), ...lines].join("\n");
// };

// src/views/hrms/attendance/utils/attendanceUtils.js

// ─── Formatters ───────────────────────────────────────────────────────────────

export const fmtHM = (mins) => {
  const m  = Math.max(0, Math.round(mins || 0));
  const h  = Math.floor(m / 60);
  const mm = m % 60;
  return `${String(h).padStart(2, "0")}h ${String(mm).padStart(2, "0")}m`;
};

export const ymd = (v) => {
  const d = new Date(v);
  if (isNaN(d)) return null;
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("-");
};

export const todayISO = () => ymd(new Date());

// ─── Status config ────────────────────────────────────────────────────────────
// Single source of truth for label, color, and filter matching.

export const STATUS_CONFIG = {
  Present:    { label: "Present",    bg: "bg-green-100",   text: "text-green-700"   },
  HalfDay:    { label: "Half Day",   bg: "bg-amber-100",   text: "text-amber-700"   },
  Late:       { label: "Late",       bg: "bg-orange-100",  text: "text-orange-700"  },
  Absent:     { label: "Absent",     bg: "bg-red-100",     text: "text-red-700"     },
  WeeklyOff:  { label: "Weekly Off", bg: "bg-blue-100",    text: "text-blue-700"    },
  Holiday:    { label: "Holiday",    bg: "bg-purple-100",  text: "text-purple-700"  },
  Leave:      { label: "Leave",      bg: "bg-indigo-100",  text: "text-indigo-700"  },
};

export const statusBadgeClass = (status) => {
  const cfg = STATUS_CONFIG[status];
  if (!cfg) return "bg-gray-100 text-gray-700";
  return `${cfg.bg} ${cfg.text}`;
};

// ─── Attendance doc helpers ───────────────────────────────────────────────────

export const pickEmployeeIdFromDoc = (doc) => {
  const e = doc?.employee;
  if (!e) return "";
  if (typeof e === "string") return e;
  if (typeof e === "object") return String(e._id || e.id || e.code || "");
  return "";
};

export const msToMin = (ms) => Math.max(0, Math.round((ms || 0) / 60000));

/**
 * Derive attendance status from the backend doc.
 *
 * Priority:
 *   1. deduction === "HALF_DAY"  → Late (punched in late, half day deducted)
 *   2. workedMin >= 480 (8h)     → Present
 *   3. workedMin >= 240 (4h)     → Half Day
 *   4. any session exists        → Half Day (came but left early)
 *   5. no sessions               → Absent
 *
 * WeeklyOff and Holiday are NOT derivable from attendance docs alone —
 * they are injected by the hook when it detects a missing doc on a known off day.
 */
export const deriveAttendanceStatus = (doc) => {
  // Leave
  if (doc?.status === "leave") return "Leave";

  // Holiday (set by server or injected by hook)
  if (doc?.status === "holiday") return "Holiday";

  // Weekly off (injected by hook for days with no doc)
  if (doc?._weeklyOff) return "WeeklyOff";

  const state    = String(doc?.state || "").toUpperCase();
  const isLive   = state === "IN" || state === "BREAK";
  const workedMin = msToMin(doc?.workedMs);
  const hasSessions = Array.isArray(doc?.sessions) && doc.sessions.length > 0;
  const hasIn    = !!(doc?.clockIn || doc?.sessions?.[0]?.in);

  // Late punch-in with half day deduction
  if (doc?.deduction === "HALF_DAY") return "Late";

  if (isLive || workedMin >= 480) return "Present";
  if (workedMin >= 240)           return "HalfDay";
  if (hasSessions || hasIn)       return "HalfDay";

  return "Absent";
};

export const computeViewFromAttendance = (doc) => {
  const workDay      = doc?.workDay || ymd(doc?.createdAt) || ymd(Date.now());
  const sessions     = Array.isArray(doc?.sessions) ? doc.sessions : [];
  const firstSession = sessions[0];
  const lastSession  = sessions[sessions.length - 1];
  const rawIn        = doc?.clockIn  || firstSession?.in  || null;
  const rawOut       = doc?.clockOut || lastSession?.out   || null;
  const workedMin    = msToMin(doc?.workedMs);
  const breakMin     = msToMin(doc?.breakMs);

  const fmt12 = (v) => {
    const dt = v ? new Date(v) : null;
    return dt instanceof Date && !isNaN(dt)
      ? dt.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
      : null;
  };

  const employeeId = pickEmployeeIdFromDoc(doc);
  const empPop     = typeof doc?.employee === "object" ? doc.employee : null;
  const status     = deriveAttendanceStatus(doc);

  return {
    _id:          String(doc._id || ""),
    employeeId,
    _empPop:      empPop,
    date:         `${workDay}T00:00:00.000Z`,
    workDay,
    in:           fmt12(rawIn)  || "",
    out:          fmt12(rawOut) || "",
    hours:        fmtHM(workedMin),
    status,                           // ← now one of the STATUS_CONFIG keys
    punchInStatus: doc?.punchInStatus ?? null,
    deduction:     doc?.deduction     ?? null,
    lateByMins:    doc?.lateByMins    ?? null,
    _breakMin:     breakMin,
    _totalMin:     workedMin,
    _firstIn:      rawIn  ? new Date(rawIn)  : null,
    _lastOut:      rawOut ? new Date(rawOut) : null,
    _live:         String(doc?.state || "").toUpperCase() === "IN" ||
                   String(doc?.state || "").toUpperCase() === "BREAK",
    _weeklyOff:    doc?._weeklyOff || false,
    _holiday:      doc?._holiday   || false,
  };
};

// ─── Geo helpers ──────────────────────────────────────────────────────────────

export const haversineKm = (a, b) => {
  if (
    !a || !b ||
    !Number.isFinite(a.lat) || !Number.isFinite(a.lng) ||
    !Number.isFinite(b.lat) || !Number.isFinite(b.lng)
  ) return Infinity;

  const R    = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const la1  = (a.lat * Math.PI) / 180;
  const la2  = (b.lat * Math.PI) / 180;
  const s1   = Math.sin(dLat / 2);
  const s2   = Math.sin(dLng / 2);
  return 2 * R * Math.asin(Math.sqrt(s1 * s1 + Math.cos(la1) * Math.cos(la2) * s2 * s2));
};

export const rangeLabel = (km) => {
  if (!Number.isFinite(km)) return "No GPS";
  if (km <= 0.5) return "In Office";
  if (km <= 1.5) return "Nearby";
  if (km <= 5)   return "Moderate";
  return "Far";
};

export const rangeToneClass = (distKm) => {
  if (!Number.isFinite(distKm)) return "bg-gray-100 text-gray-700";
  if (distKm <= 0.5)            return "bg-emerald-100 text-emerald-700";
  if (distKm <= 1.5)            return "bg-blue-100 text-blue-700";
  if (distKm <= 5)              return "bg-amber-100 text-amber-700";
  return "bg-rose-100 text-rose-700";
};

// ─── Employee helpers ─────────────────────────────────────────────────────────

export const getEmployeeDisplayName = (e) => {
  if (!e) return "";
  if (e.name) return e.name;
  const fn = e.firstName || "";
  const ln = e.lastName  || "";
  return (fn + " " + ln).trim() || e.code || e.id || "";
};

// ─── Date helpers ─────────────────────────────────────────────────────────────

export const pickDate = (r) => {
  const candidates = [
    r?.date,
    r?.workDay && `${r.workDay}T00:00:00Z`,
    r?.sessions?.[0]?.in,
    r?.createdAt,
    r?.updatedAt,
  ].filter(Boolean);

  for (const c of candidates) {
    const d = new Date(c);
    if (!Number.isNaN(d.getTime())) return d;
  }
  return null;
};

export const getMonthRange = (type) => {
  const now   = new Date();
  const year  = now.getFullYear();
  const month = now.getMonth();

  if (type === "thisMonth") {
    return {
      from: ymd(new Date(year, month, 1)),
      to:   ymd(new Date(year, month + 1, 0)),
    };
  }
  if (type === "lastMonth") {
    return {
      from: ymd(new Date(year, month - 1, 1)),
      to:   ymd(new Date(year, month, 0)),
    };
  }
  return null;
};

// ─── CSV export ───────────────────────────────────────────────────────────────

export const toCSV = (rows) => {
  const headers = [
    "Employee ID", "Employee", "Date",
    "Check In", "Check Out", "Hours", "Break (min)",
    "Status", "Late By (mins)", "Deduction",
    "Range Label", "Range (km)",
  ];

  const escape = (v) => `"${String(v || "").replace(/"/g, '""')}"`;

  const lines = rows.map((r) => {
    const id   = String(r.employeeId || r.employee || "");
    const name = r._displayName || "";
    const day  = ymd(pickDate(r)) || r.workDay || "";
    const dist = Number.isFinite(r._distKm) ? r._distKm.toFixed(2) : "";

    return [
      escape(id),
      escape(name),
      day,
      r.in   || "",
      r.out  || "",
      r.hours || "",
      r._breakMin || "",
      STATUS_CONFIG[r.status]?.label || r.status || "",
      r.lateByMins ?? "",
      r.deduction  ?? "",
      r._distLabel || "",
      dist,
    ].join(",");
  });

  return [headers.join(","), ...lines].join("\n");
};